import CloseIcon from '@mui/icons-material/Close';
import AppBar from '@mui/material/AppBar';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Slide from '@mui/material/Slide';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { useEffect } from 'react';
import { TextField } from '@mui/material';
import './styles.css';
import { useColors } from 'frontend/hooks/useColors';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function OrigenDestinoFullScreenDialog({
  options,
  onSelect,
  originSelected,
  disabled,
  isDestination,
  isDestinationEmpty,
  isOriginEmpty,
  setIsOriginEmpty,
  setIsDestinationEmpty,
  isOpen,
  setIsDestinationDialogOpen,
  setIsFullScreenRangeDatePickerOpen,
  setSearchValue,
  isFlight,
  handleAirportChange,
  searchValue
}) {
  const [open, setOpen] = React.useState(false);
  const [optionTapped, setOptionTapped] = React.useState(undefined);
  const [filteredOptions, setFilteredOptions] = React.useState(options || []);

  const { background } = useColors();

  const handleClickOpen = () => {
    setOpen(true);
    setOptionTapped(undefined);
    setFilteredOptions(options || []);
  };

  const handleClose = () => {
    setOptionTapped(undefined);
    setOpen(false);
  };

  const handleNext = () => {
    if (!optionTapped) return;
    
    onSelect(optionTapped);
    setOpen(false);
    
    if (isDestination) {
      setIsDestinationEmpty(false);
      setIsDestinationDialogOpen(false);
      setIsFullScreenRangeDatePickerOpen(true);
    } else {
      setIsOriginEmpty(false);
      setIsDestinationDialogOpen(true);
    }
  };

  const handleSearch = (event) => {
    const searchValue = event.target.value;
    
    if (setSearchValue) {
      setSearchValue(searchValue);
    }

    if (typeof handleAirportChange === 'function') {
      handleAirportChange(null, searchValue, !isDestination);
    }
  };

  const handleOptionSelect = (option) => {
    setOptionTapped(option);
  };

  useEffect(() => {
    if (isOpen) {
      setOpen(true);
      setOptionTapped(undefined);
      setFilteredOptions(options || []);
    }
  }, [isOpen, options]);

  useEffect(() => {
    setFilteredOptions(options || []);
  }, [options]);

  return (
    <>
      <div
        onClick={() => {
          if (!disabled) handleClickOpen();
        }}
        className={`full-screen-dialog ${
          isDestinationEmpty || isOriginEmpty ? 'autocomplete-error' : ''
        }`}
      >
        {isFlight && originSelected
          ? `${originSelected.airportName} (${originSelected.airportCode}) - ${originSelected.cityName}`
          : originSelected?.name || ' '}
      </div>

      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
        disableEnforceFocus
      >
        <AppBar sx={{ position: 'relative', backgroundColor: background }}>
          <Toolbar>
            <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              {isDestination ? 'Destino' : 'Origen'}
            </Typography>
            {optionTapped && (
              <Button autoFocus color="inherit" onClick={handleNext}>
                Siguiente
              </Button>
            )}
          </Toolbar>
        </AppBar>
        <DialogTitle>Escriba para buscar una opción</DialogTitle>

        <DialogContent
          sx={{
            overflowY: 'scroll',
            maxHeight: '90vh',
          }}
        >
          <TextField
            fullWidth
            value={searchValue || ''}
            onChange={handleSearch}
            sx={{ marginBottom: '1rem' }}
            placeholder="Buscar"
            autoFocus
            inputProps={{
              autoComplete: 'off',
              autoCorrect: 'off',
              autoCapitalize: 'off',
              spellCheck: 'false'
            }}
          />
          {!options ? (
            <Typography color="textSecondary" sx={{ mt: 2 }}>
              Cargando...
            </Typography>
          ) : filteredOptions.length === 0 && searchValue?.trim() !== '' ? (
            <Typography color="textSecondary" sx={{ mt: 2 }}>
              Sin resultados
            </Typography>
          ) : filteredOptions.length === 0 ? (
            <Typography color="textSecondary" sx={{ mt: 2 }}>
              Escriba para buscar
            </Typography>
          ) : (
            <List>
              {filteredOptions.map((option, index) => (
                <ListItem
                  button
                  key={index}
                  onClick={() => handleOptionSelect(option)}
                  selected={option.id?.[0] === optionTapped?.id?.[0]}
                  style={option.id?.[0] === originSelected?.id?.[0] ? { backgroundColor: '#0001' } : {}}
                >
                  <ListItemText
                    primary={
                      isFlight
                        ? `${option.airportName} (${option.airportCode}) - ${option.cityName}`
                        : option.name
                    }
                  />
                </ListItem>
              ))}
            </List>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}
